import { createContext, ReactNode, useContext, useState } from 'react';

const WillBeNullContext = createContext<{
    willBeNull: boolean;
    setWillBeNull: (willBeNull: boolean) => void;
}>({
    willBeNull: false,
    setWillBeNull: () => null,
});

/*
 * The goal of this provider is to render a null further up the component tree
 * when a deeply nested child will end up rendering null itself.
 */
export function WillBeNullProvider({
    children,
    handleWillBeNull,
}: {
    children: ReactNode;
    handleWillBeNull: () => void;
}) {
    const [willBeNull, _setWillBeNull] = useState(false);
    const setWillBeNull = (b: boolean) => {
        _setWillBeNull(b);
        handleWillBeNull();
    };

    if (willBeNull) {
        return null;
    }

    return (
        <WillBeNullContext.Provider value={{ willBeNull, setWillBeNull }}>
            {children}
        </WillBeNullContext.Provider>
    );
}

export function useWillBeNull() {
    const context = useContext(WillBeNullContext);
    return context;
}
